import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e5138642"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "period-week",
  class: "grid-container scrolled"
}
const _hoisted_2 = { class: "grid-container week-row" }
const _hoisted_3 = { class: "sc-top-info" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "sc-appointments" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "ap-top-info" }
const _hoisted_8 = { class: "ap-patient" }
const _hoisted_9 = { class: "sc-bottom-info" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "ap-top-info" }
const _hoisted_12 = { class: "ap-patient" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.week_days, (wd) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "week-day",
          key: wd.weekDay
        }, [
          _createElementVNode("span", null, _toDisplayString(wd.weekDay), 1),
          _createVNode(_component_router_link, {
            class: _normalizeClass(["link-month-day", { 'is-today': wd.isToday }]),
            to: {
            name: 'day',
            params: { day: wd.day, month: wd.month + 1, year: wd.year },
          }
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(wd.day), 1)
            ]),
            _: 2
          }, 1032, ["class", "to"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["grid-container week-hours-area", { 'empty-days': false }])
    }, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.week_agenda, (aps, wkd) => {
        return (_openBlock(), _createElementBlock("div", {
          key: wkd,
          class: _normalizeClass(['week-day-column'])
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aps, (scap) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: scap.key
            }, [
              (scap.appointments !== undefined)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "day-schedule",
                    style: _normalizeStyle({ 'min-height': scap.height + 'em' })
                  }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("span", null, _toDisplayString(scap.start_time.toClockTime()), 1),
                      _createElementVNode("strong", null, _toDisplayString(scap.specialty), 1),
                      _createElementVNode("a", {
                        class: "icon-new-appointment",
                        onClick: ($event: any) => (
                    _ctx.initRecord({
                      scheduled_day: scap.date,
                      start_time: scap.start_time,
                    })
                  )
                      }, [
                        _createVNode(_component_font_awesome_icon, { icon: ['fa', 'plus'] })
                      ], 8, _hoisted_4)
                    ]),
                    _createElementVNode("div", _hoisted_5, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scap.appointments, (sap) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "day-appointment",
                          style: _normalizeStyle({ height: sap.height + 'em' }),
                          key: sap.key,
                          onClick: ($event: any) => (_ctx.initUpdateRecord(sap.appointment_id))
                        }, [
                          _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("span", null, _toDisplayString(sap.start_time.toClockTime()), 1),
                            _createElementVNode("span", {
                              class: _normalizeClass({ 'not-end-time': !sap.end_time })
                            }, _toDisplayString(sap.end_time ? sap.end_time.toClockTime() : "88:88"), 3)
                          ]),
                          _createElementVNode("div", _hoisted_8, _toDisplayString(sap.patient), 1)
                        ], 12, _hoisted_6))
                      }), 128))
                    ]),
                    _createElementVNode("span", _hoisted_9, [
                      _createElementVNode("span", null, _toDisplayString(scap.appointments.length) + "/" + _toDisplayString(scap.max_visits), 1),
                      _createElementVNode("span", null, _toDisplayString(scap.end_time.toClockTime()), 1)
                    ])
                  ], 4))
                : (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    class: "day-appointment",
                    style: _normalizeStyle({ height: scap.height + 'em' }),
                    onClick: ($event: any) => (_ctx.initUpdateRecord(scap.appointment_id))
                  }, [
                    _createElementVNode("div", _hoisted_11, [
                      _createElementVNode("span", null, _toDisplayString(scap.start_time.toClockTime()), 1),
                      _createElementVNode("strong", null, _toDisplayString(scap.specialty), 1),
                      _createElementVNode("span", {
                        class: _normalizeClass({ 'not-end-time': !scap.end_time })
                      }, _toDisplayString(scap.end_time ? scap.end_time.toClockTime() : "88:88"), 3)
                    ]),
                    _createElementVNode("div", _hoisted_12, _toDisplayString(scap.patient), 1)
                  ], 12, _hoisted_10))
            ], 64))
          }), 128))
        ]))
      }), 128))
    ])
  ]))
}